export const ApiUrl = "https://digital-menu-card-server.vercel.app/api";
export const clientUrl = "https://create-your-digital-menu-card.vercel.app";
// export const ApiUrl = "http://localhost:5000/api";
// export const clientUrl = "http://localhost:3000";
